<script setup lang="ts">
import LoaderDefault from '../common/LoaderDefault.vue'
import CardComponent from './CardComponent.vue'
import { computed, type Component } from 'vue'

interface Props {
  // Required props
  title: string
  value: string | number

  // Optional props
  icon?: Component // Use Component type for Vue components
  isLoading?: boolean
  formatValue?: (value: string | number) => string
}

const props = withDefaults(defineProps<Props>(), {
  isLoading: false,
  formatValue: (value: string | number) => value.toString()
})

// Compute formatted value
const formattedValue = computed(() => {
  return props.formatValue!(props.value)
})
</script>

<template>
  <CardComponent bodyClass="gap-2">
    <template #body>
      <LoaderDefault
        v-if="isLoading"
        title="Loading server data..."
      />

      <div v-else class="flex flex-1 items-center justify-between">
        <p class="flex items-center gap-2 flex-1">
          <component
            v-if="icon"
            :is="icon"
            class="w-7 h-7"
            aria-hidden="true"
          />
          {{ title }}
        </p>
        <div class="flex items-center justify-center data-highlight">
          {{ formattedValue }}
        </div>
      </div>
    </template>
  </CardComponent>
</template>

<style scoped>
/* Custom styles if needed */
</style>
